import { gql } from '@apollo/client';

/**
 * ERP #110 — предпроверка «Исправить группу» / «Отменить зачисление».
 *
 * Имя операции отлично от имени поля (`agreementCorrectionCheck`): иначе
 * codegen склеил бы тип результата с типом ответа схемы.
 *
 * Без `targetGroupId` в `correctBlockers` только то, что не зависит от выбора
 * группы; после выбора группы запрос повторяется с `targetGroupId`. Коды
 * блокеров и предупреждений фронт переводит сам (`agreementCorrection.*`).
 */
export const agreementCorrectionPrecheckDocument = gql`
  query AgreementCorrectionPrecheck($agreementId: ID!, $targetGroupId: ID) {
    agreementCorrectionCheck(
      agreementId: $agreementId
      targetGroupId: $targetGroupId
    ) {
      canCorrect
      canUndo
      correctBlockers
      undoBlockers
      warnings
      undoDeadline
    }
  }
`;
